import { useDispatch } from "react-redux";
import { multiUpdateGlobalState } from "src/features/globalSlice";
import SvgIcon from "../../shared/minicomponents/SvgIcon";
import s from "./AccountMenuIcon.module.scss";

const AccountMenuIcon = () => {
  const dispatch = useDispatch();

  return (
    <button
      type="button"
      className={s.profileSectionsButton}
      aria-label="List of Profile sections"
      title="section list"
      onClick={() => openProfileMenu(dispatch)}
    >
      <SvgIcon name="list" />
    </button>
  );
};
export default AccountMenuIcon;

function openProfileMenu(dispatch) {
  const payload = {
    isProfileMenuActive: true,
    isOverlayActive: true,
  };
  dispatch(multiUpdateGlobalState(payload));
}
